<template>
  <a-modal
    v-bind="attrs"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :centered="true"
    :title="getTitle()"
    okText="确认"
    :zIndex="1010"
  >
    <template v-if="store.deleteFolderData?.fileIds?.length > 0">
      <div class="mt-20">您想如何处理所选的素材呢？此操作不可恢复请谨慎操作。</div>
      <a-radio-group class="mt-10 mb-20" v-model:value="selectValue">
        <a-radio class="mb-10" style="width: 100%" value="2"> 仅删除所选素材 </a-radio>
        <a-radio style="width: 100%" value="1"> 删除所选素材和相似的素材 </a-radio>
      </a-radio-group>
    </template>
    <div class="mt-20" v-else>是否确认删除，此操作不可恢复请谨慎操作。</div>
  </a-modal>
</template>

<script setup>
import {
  Modal as AModal,
  RadioGroup as ARadioGroup,
  Radio as ARadio,
  message
} from 'ant-design-vue'
import { ref, useAttrs, watch } from 'vue'
import { aigcStore } from '@/store/aigcStore'
import { deleteFolder } from '@/service/api/aiDam'
import eventsBus from '@/utils/eventsBus'

const emits = defineEmits(['asyncSuccess'])

const store = aigcStore()
const attrs = useAttrs()
const confirmLoading = ref(false)
const selectValue = ref('2')

const getTitle = () => {
  let str = ''
  if (
    (store.deleteFolderData?.modalType === 'deleteMore' &&
      store.deleteFolderData?.fileIds.length == 0) ||
    !store.deleteFolderData?.modalType
  ) {
    str = '文件夹'
  }
  return '删除' + str
}
const handleOk = () => {
  confirmLoading.value = true
  let obj = null
  if (store.deleteFolderData?.modalType === 'deleteMore') {
    obj = {
      folderIdList: store.deleteFolderData?.folderIds,
      fileIdList: store.deleteFolderData?.fileIds,
      mateType: selectValue.value,
      copyType: '0'
    }
  } else {
    obj = {
      folderId: store.deleteFolderData?.id,
      mateType: selectValue.value,
      copyType: '0'
    }
  }
  deleteFolder(obj, store.deleteFolderData?.id).then((res) => {
    if (res.data) {
      message.success('删除成功')
      if (store.deleteFolderData?.modalType === 'deleteMore') {
        eventsBus.emit('damUpdate', true)
      } else {
        if (store.deleteFolderData?.id === store.selectList[0]) {
          store.selectList[0] = '0'
        }
        eventsBus.emit('deleteFolder')
      }
      emits('asyncSuccess', store.deleteFolderData?.id)
    }
    confirmLoading.value = false
  })
}

watch(
  () => attrs.open,
  (val) => {
    confirmLoading.value = false
    if (val) {
      selectValue.value = '2'
    }
  }
)
</script>

<style lang="less" scoped></style>
